module.exports = __webpack_public_path__ + "img/floor_bg.2364335f.png";